module.exports = __webpack_public_path__ + "static/media/coupon_without_detail_title.bce2a9e3.svg";